import styled, { css, keyframes } from 'styled-components';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';

// One-time attention pulse used the first time a user opens a detail drawer,
// to point them at the new location of engagement data.
const glowPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(0, 122, 222, 0.55);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 122, 222, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 122, 222, 0);
  }
`;

const glowStyles = css`
  border-radius: 8px;
  animation: ${glowPulse} 1.6s ease-out 4;
`;

export const Section = styled.div`
  background: #ffffff;
  margin-top: 8px;
  margin-bottom: 24px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  width: 100%;
  ${({ $glow }) => $glow && glowStyles};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const Title = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const TitleIcon = styled(TrendingUpIcon)`
  color: #007ade;
  font-size: 20px !important;
`;

export const ViewAllButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #007ade;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-top: 1px solid #eef0f3;

  th:nth-child(1),
  td:nth-child(1) {
    width: 13%;
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 40%;
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 24%;
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 23%;
  }
`;

export const TableHead = styled.thead``;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr``;

export const TableHeaderCell = styled.th`
  box-sizing: border-box;
  padding: 10px 8px;
  text-align: left;
  border-bottom: 1px solid #eef0f3;
`;

export const TableCell = styled.td`
  box-sizing: border-box;
  padding: 12px 8px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
`;

export const ColLabel = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
`;

export const CellContent = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #1f2937;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const Subject = styled.p`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #1f2937;
  font-weight: 600;
  display: block;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background: ${props => (props.$on ? '#22c55e' : '#d1d5db')};
`;

export const Dash = styled.span`
  color: #9ca3af;
`;

export const Empty = styled.p`
  margin: 0;
  padding: 16px 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
`;
